import React, { useState, useRef, useEffect, useCallback } from 'react';
import styles from './index.module.scss';
import { useStore, StoreTypes } from 'context';
import { EventBus, EventBusType } from 'events/EventBus';
import { ReaderEvent, ReaderToolsEvent } from 'events/EventTypes';
import { ReaderZoomType, ReaderToolType } from 'constants/ReaderTools';
import * as types from 'constants/actionTypes';
import { SideToolContent } from 'constants/sideToolContents';
import { getDeviceXY } from 'util/device'
import classnames from 'classnames';

const DrawArea = ({ drawAreaInfo, eventBusType }) => {
    const [{ style, bookContent }] = useStore(StoreTypes.books);
    const [, readerDispatch] = useStore(StoreTypes.reader);
    const [{ sideToolContent }] = useStore(StoreTypes.sideTool);
    const [isMove, setIsMove] = useState(0)
    const [rect, setRect] = useState({ x: 0, y: 0, width: 0, heght: 0 })
    const [livestreamElementInfo, setLivestreamElementInfo] = useState({ height: 0 })
    const rectRef = useRef();
    const [bookRangeInfo, setBookRangeInfo] = useState(null)

    useEffect(() => {
        if (!bookContent) return;
        const getBookContent = bookContent[Object.keys(bookContent).find((key) => bookContent[key])]
        if (!getBookContent) return;
        const pageContentWidth = getBookContent.width * 2
        const pageContentHeight = getBookContent.height
        const scale = (style.width / pageContentWidth)
        const pageWidth = pageContentWidth * scale
        const pageHeight = pageContentHeight * scale
        const offsetX = ((style.width - pageWidth) / 2)
        const offsetY = ((style.height - pageHeight) / 2)

        setBookRangeInfo({ offsetX, offsetY, width: pageWidth, height: pageHeight })
        return () => {
            if (eventBusType) {
                // 小視窗模式：只發送小視窗事件
                EventBus.emit({ 
                    eventBusType,
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
            } else {
                // 主 reader 模式：只發送主 reader 事件
                EventBus.emit({ 
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
            }
            setIsMove(0)
        }
    }, [style, bookContent])

    const mouseDownHandler = useCallback((e) => {
        e.preventDefault(); // 防止瀏覽器預設的文字選取/拖放行為
        if (document.activeElement) {
            document.activeElement.blur();
        }
        if (!bookRangeInfo) { return; }
        const { deviceX, deviceY } = getDeviceXY(e)
        //console.log(deviceX,deviceY)
        setIsMove(1)
        // mouseDown 時立即將 toolType 切回 Drag，讓「區間放大」按鈕回到未選取狀態
        // if (eventBusType) {
        //     EventBus.emit({
        //         eventBusType,
        //         event: ReaderToolsEvent.SetReaderToolTypeEvent,
        //         payload: { toolType: ReaderToolType.Drag }
        //     });
        // } else {
        //     EventBus.emit({
        //         event: ReaderToolsEvent.SetReaderToolTypeEvent,
        //         payload: { toolType: ReaderToolType.Drag }
        //     });
        // }
        if (deviceX - bookRangeInfo.offsetX < 0 || deviceY - bookRangeInfo.offsetY < 0) {
            if (eventBusType) {
                // 小視窗模式：只發送小視窗事件
                EventBus.emit({ 
                    eventBusType,
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
            } else {
                // 主 reader 模式：只發送主 reader 事件
                EventBus.emit({ 
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
            }
            return;
        }
        const { width, height } = rect;
        setRect({ x: deviceX, y: deviceY, width, height })
        rectRef.current.style.top = `${(deviceY)}px`
        rectRef.current.style.left = `${(deviceX)}px`
    }, [bookRangeInfo, eventBusType])

    const mouseMoveHandler = (e) => {
        if (isMove === 0) {
            return;
        }
        const { deviceX, deviceY } = getDeviceXY(e)
        const { x, y } = rect;
        rectRef.current.style.position = "absolute"
        rectRef.current.style.backgroundColor = "aqua"
        rectRef.current.style.left = `${Math.min(x, deviceX)}px`
        rectRef.current.style.top = `${Math.min(y, deviceY)}px`
        rectRef.current.style.width = `${Math.abs(deviceX - x)}px`
        rectRef.current.style.height = `${Math.abs(deviceY - y)}px`
        //console.log(x,y,(deviceX - x),(deviceY - y))
        setRect({ x, y, width: (deviceX - x), height: (deviceY - y) })
        setIsMove(2)
    }

    const mouseUpHandler = (e) => {
        if (isMove === 2 ) {
            if (eventBusType) {
                // 小視窗模式：只發送小視窗事件
                EventBus.emit({ 
                    eventBusType,
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
                // EventBus.emit({
                //     event: ReaderToolsEvent.SetReaderToolTypeEvent,
                //     payload: { toolType: ReaderToolType.Drag }
                // });
            } else {
                // 主 reader 模式：只發送主 reader 事件
                EventBus.emit({ 
                    event: ReaderEvent.DrawAreaEvent, 
                    payload: { drawAreaInfo: { isDrawArea: false, callback: null, step: null } } 
                });
                // EventBus.emit({
                //     event: ReaderToolsEvent.SetReaderToolTypeEvent,
                //     payload: { toolType: ReaderToolType.Drag }
                // });
            }
            const getBookContent = bookContent[Object.keys(bookContent).find((key) => bookContent[key])]
            if (getBookContent) {
                let { x, y, width, height } = rect;

                const pageContentWidth = getBookContent.width * 2
                const pageContentHeight = getBookContent.height
                const scaleWidth = (style.width / pageContentWidth)
                const scale = (style.height / pageContentHeight)
                const originScale = (pageContentHeight / style.height)
                const offsetX = ((style.width - pageContentWidth * scaleWidth) / 2)
                const offsetY = ((style.height - pageContentHeight * scaleWidth) / 2)
                const nowPageWidth = pageContentWidth * scaleWidth
                const nowPageHeight = style.height//pageContentHeight * scaleWidth
                const areaZoomInfo = {
                    originScale,
                    originX: x,
                    originY: y,
                    originWidth: width,
                    originHeight: height,
                    originXScale: x / nowPageWidth,
                    originYScale: y / nowPageHeight,
                    originXScale2: (x - bookRangeInfo.offsetX) / nowPageWidth,
                    originYScale2: (y - bookRangeInfo.offsetY) / nowPageHeight,
                    originWidthScale: width / nowPageWidth,
                    originHeightScale: height / nowPageHeight,
                    offsetX,
                    offsetY,
                    x: (x - offsetX) * originScale,
                    y: (y - offsetY) * originScale,
                    width: (width * originScale),
                    height: ((height) * originScale)
                }

                if (drawAreaInfo.step != null) {
                    drawAreaInfo.callback({ areaZoomInfo: { ...areaZoomInfo, step: drawAreaInfo.step } })
                }

                if (sideToolContent === SideToolContent.None) {
                    if (eventBusType) {
                        // 小視窗模式：使用 ExtendedContent eventBus 發送區域縮放事件
                        EventBus.emit({ 
                            eventBusType,
                            event: ReaderEvent.AreaZoomEvent, 
                            payload: { type: ReaderZoomType.RangeZoom, rect: areaZoomInfo } 
                        });
                    } else {
                        // 主 reader 模式：發送主 reader 區域縮放事件
                        EventBus.emit({ 
                            event: ReaderEvent.AreaZoomEvent, 
                            payload: { type: ReaderZoomType.RangeZoom, rect: areaZoomInfo } 
                        });
                    }
                }
            }
        }
        setIsMove(0)
        if (eventBusType) {
            EventBus.emit({
                eventBusType,
                event: ReaderToolsEvent.SetReaderToolTypeEvent,
                payload: { toolType: ReaderToolType.Drag }
            });
        } else {
            EventBus.emit({
                event: ReaderToolsEvent.SetReaderToolTypeEvent,
                payload: { toolType: ReaderToolType.Drag }
            });
        }
    }

    return (
        <div
            id="drawArea"
            className={classnames(styles.drawArea, {
                [styles.extendedDrawArea]: eventBusType === EventBusType.ExtendedContent
            })}            onMouseDown={(e) => { mouseDownHandler(e) }}
            onMouseMove={(e) => { mouseMoveHandler(e) }}
            onMouseUp={(e) => { mouseUpHandler(e) }}
            onTouchStart={(e) => { mouseDownHandler(e) }}
            onTouchMove={(e) => { mouseMoveHandler(e) }}
            onTouchEnd={(e) => { mouseUpHandler(e) }}
        >
            <div ref={rectRef}></div>
        </div>
    );
};

export default DrawArea;
